/* Import Local Modules */
import Util from "./Util.js";
/**
 * Formats numerical values.
 * @param {Number} value - Numerical value to be formatted.
 * @param {Number} options.maxDecimals - Maximun number of decimals.
 * @param {Boolean} options.fixed - Pad decimals with zeros.
 */
function format(value, options) {
  // Get parameters
  const {
    maxDecimals,
    fixed,
    prefix,
    suffix,
    localize
  } = options;

  // Validate parameters
  if (value == null) {
    return ['-'];
  }
  if (typeof value !== 'number') {
    return [value];
  }
  if (maxDecimals == null) {
    return [localize ? value.toLocaleString() : value.toString()];
  }

  // Format value
  let formattedValue;
  if (localize) {
    formattedValue = fixed ? Number(value).toLocaleString(undefined, {
      maximumFractionDigits: maxDecimals,
      minimumFractionDigits: maxDecimals
    }) : Number(value).toLocaleString(undefined, {
      maximumFractionDigits: maxDecimals
    });
  } else {
    formattedValue = fixed ? Number(value).toFixed(maxDecimals) : Util.trimDecimals(value, maxDecimals);
  }

  // Return formatted value
  if (prefix) {
    if (suffix) {
      return [prefix + formattedValue + suffix];
    }
    return [prefix + formattedValue];
  }
  if (suffix) {
    return [formattedValue + suffix];
  }
  return [formattedValue];
}
export default {
  format
};